export default __webpack_public_path__ + "img/title-404.png?1f1d";